import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import animations from 'src/styles/animations';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, animations.spin), {}, {
  dropzoneContainer: {
    maxWidth: '100%',
    minHeight: '180px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch'
  },
  largeDropzoneContainer: {
    minHeight: '240px'
  },
  dropzoneContent: {
    padding: '0 40px',
    width: '100%',
    background: palette.shades[100],
    borderRadius: '2px',
    border: "1px dashed ".concat(palette.shades[600]),
    transition: "all ".concat(palette.transitions.short),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      background: palette.shades[200],
      borderColor: palette.shades[700],
      '& .MuiSvgIcon-root path': {
        fill: palette.shades[800]
      }
    }
  },
  dropzoneDragover: {
    background: palette.success.gradient,
    '& .MuiSvgIcon-root path': {
      fill: palette.shades[800]
    },
    '&:hover': {
      background: palette.success.gradient,
      '& .MuiSvgIcon-root path': {
        fill: palette.shades[800]
      }
    }
  },
  dropzoneError: {
    background: palette.error.gradient,
    '& .MuiSvgIcon-root path': {
      fill: palette.error.main
    },
    '&:hover': {
      background: palette.error.gradient,
      '& .MuiSvgIcon-root path': {
        fill: palette.error.main
      }
    }
  },
  dropzoneInfo: {
    background: palette.info.gradient,
    '& .MuiSvgIcon-root path': {
      fill: palette.info.main
    },
    '&:hover': {
      background: palette.info.gradient,
      '& .MuiSvgIcon-root path': {
        fill: palette.info.main
      }
    }
  },
  dropzoneSuccess: {
    background: palette.success.gradient,
    '& .MuiSvgIcon-root path': {
      fill: palette.success.main
    },
    '&:hover': {
      background: palette.success.gradient,
      '& .MuiSvgIcon-root path': {
        fill: palette.success.main
      }
    }
  },
  hint: {
    marginBottom: '10px',
    marginTop: '10px',
    '& span': {
      color: palette.primary.main
    }
  },
  hintGrey: {
    color: palette.shades[700]
  },
  spinner: {
    animation: '$spin 1.3s infinite linear'
  }
}));
export default useStyles;